<template>
  <div class="animated fadeIn gofixTables" v-bind:class="{'run-loading':actionStatus.listLoading}">
    <b-row v-if="tableControls.reload ||
        tableControls.create ||
        tableControls.delete ||
        tableControls.reply ||
        tableControls.caseStatus ||
        tableControls.createPWO ||
        tableControls.linkCase ||
        tableControls.markAsUnread ||
        tableControls.newCase ||
        tableControls.resend ||
        tableControls.emailAssign ||
        tableControls.enable ||
        tableControls.disable ||
        tableControls.assign ||
        tableControls.changeStatus ||
        tableControls.allItems ||
        tableControls.tablePagination ||
        tableControls.tableImport ||
        tableControls.tableExport ||
        tableControls.tableExportCaseNLT ||
        tableControls.tableColumnSettings ||
        tableControls.tableCloneMaster ||
        tableControls.linkCaseActivity ||
        tableControls.massPrint ||
        tableControls.updateWONumber ||
        tableControls.btnReschedule
">
      <b-col :md="tableSettings.leftWidth">
        <div class="dataControls">
          <ul class="controlList">
            <slot name="gofix_table:before-control-left"></slot>
            <li class="control-item" v-if="tableControls.reload">
              <a class="control-item-link cursor-pointer" id="reloadTable" @click="reloadTableItems" title="Refresh" v-b-tooltip.hover><img src="img/reLoad.png" alt="Refresh"></a>
            </li>
            <li class="control-item" v-if="tableControls.createEmail" :title="tableControls.createEmailTooltip" v-b-tooltip.hover>
              <a :class="['control-item-link cursor-pointer', {'control-item-link--disable': tableControls.disabled_create}]" @click="createNewTableEmailItem"><img src="img/emailSend.png" :alt="tableControls.createEmailTooltip"></a>
            </li>
            <li class="control-item" v-if="tableControls.create" :title="tableControls.createTooptip" v-b-tooltip.hover>
              <a id="createNewTableItem" :class="['control-item-link cursor-pointer', {'control-item-link--disable': tableControls.disabled_create}]" @click="createNewTableItem"><img src="img/blankIcon.png" :alt="tableControls.createTooptip"></a>
            </li>
            <slot name="gofix_table:after-btn-create"></slot>
            <li class="control-item" v-if="tableControls.tableCloneMaster">
              <a class="control-item-link cursor-pointer" @click="cloneMaster" title="Clone" v-b-tooltip.hover><img :src="tableControls.tableCloneMasterIcon" alt="Clone"></a>
            </li>
            <li class="control-item" v-if="tableControls.delete && tableSelected.selected.length && !tableControls.btnReschedule">
              <a class="control-item-link cursor-pointer" @click="deleteTableItemsComfirm" title="Delete" v-b-tooltip.hover><img src="img/deleteIcon.png" alt="Delete"></a>
            </li>
            <!-- createLinkCase createLinkCaseConfirm -->
            <li class="control-item" v-if="tableControls.linkCase  && tableSelected.single">
              <a class="control-item-link cursor-pointer" @click="createLinkCase" title="Link Existing Case" v-b-tooltip.hover><img src="img/link.png" alt="Link Existing Case"></a>
            </li>

            <!-- <li class="control-item" v-if="tableControls.reply  && tableSelected.single && tableControls.caseStatus !='Closed' ">
              <a class="control-item-link cursor-pointer" @click="replyConfirm" title="Reply" v-b-tooltip.hover><img src="img/emailSend.png" alt="Reply"></a>
            </li> -->

            <!-- new link case - createLinkNewCase createNewLinkCaseConfirm-->
            <li class="control-item" v-if="tableControls.newCase  && tableSelected.single">
              <a id="createNewCaseItem" class="control-item-link cursor-pointer" @click="createLinkNewCase" title="New Case" v-b-tooltip.hover><img src="img/ant-design_file-add-outline.png" alt="New Case"></a>
            </li>

            <li class="control-item" v-if="tableControls.resend && tableSelected.single">
              <a id="createNewCaseItem" class="control-item-link cursor-pointer" @click="resendEmail" title="Resend" v-b-tooltip.hover><img src="img/resend.jpeg" alt="Resend"></a>
            </li>

            <!-- email Assignment -->
            <li class="control-item" v-if="tableControls.emailAssign  && tableSelected.single">
             <gofix-button class="mr-4" label="Assign" @click="createEmailAssign"  outline></gofix-button>
            </li>


            <li class="control-item" v-if="tableControls.markAsUnread  && tableSelected.single">
              <gofix-button class="mr-4" style="white-space: nowrap;" label="Mark As Unread" @click="markAsUnread"  outline></gofix-button>
            </li>

            <li class="control-item" v-if="tableControls.createPWO  && tableSelected.selected.length && !tableControls.btnReschedule">
              <a class="control-item-link cursor-pointer" @click="createPWOComfirm" title="Create PWO" v-b-tooltip.hover><img src="img/ant-design_file-add-outline.png" alt="Create PWO"></a>
            </li>
            <li class="control-item" v-if="tableControls.periodFilter">
              <a class="control-item-link cursor-pointer" @click="periodFilterComfirm" title="Period Filter" v-b-tooltip.hover><img src="img/dateIcon.png" alt="Period Filter"></a>
            </li>

            <li class="control-item" v-if="tableControls.enable  && tableSelected.selected.length">
              <a class="control-item-link cursor-pointer" @click="enableItems" title="Enable" v-b-tooltip.hover><img src="img/checkIcon.png" alt="Enable"></a>
            </li>
            <li class="control-item" v-if="tableControls.disable">
              <a class="control-item-link cursor-pointer" @click="disableItems" title="Disable" v-b-tooltip.hover><img src="img/disable.png" alt="Disable"></a>
            </li>
            <li class="control-item" v-if="tableControls.adjustment  && tableSelected.selected.length">
              <a class="control-item-link cursor-pointer" @click="adjustmentItems" title="Adjustment" v-b-tooltip.hover><img src="img/price.png" alt="Enable"></a>
            </li>
            <li class="control-item" v-if="tableControls.download  && tableSelected.selected.length">
              <a class="control-item-link cursor-pointer" @click="downloadItems" title="Download" v-b-tooltip.hover><img src="img/download.png" alt="Download"></a>
            </li>
            <li class="control-item" v-if="tableControls.email_send  && tableSelected.selected.length">
              <a class="control-item-link cursor-pointer" @click="emailSendItems" title="Email Send" v-b-tooltip.hover><img src="img/emailSend.png" alt="Email Send"></a>
            </li>
            <li class="control-item" v-if="tableControls.nav_file">
              <a class="control-item-link cursor-pointer" @click="navFileItems" title="NAV-File" v-b-tooltip.hover><img class="position-top h-21" src="img/navFile.png" alt="NAV-File"></a>
            </li>
            <li class="control-item" v-if="(tableControls.assign || tableControls.changeStatus) && tableSelected.selected.length">
              <b-dropdown class="btn" left v-b-tooltip.hover title="Option">
                <b-dropdown-item v-if="tableControls.assign" @click="assignItems">Assign to</b-dropdown-item>
                <b-dropdown-item v-if="tableControls.changeStatus" @click="editStatusItemsComfirm">Edit Status</b-dropdown-item>
              </b-dropdown>
            </li>
            <li class="control-item" v-if="tableControls.btnReschedule">
              <gofix-button :disabled="tableSelected.selected.length <= 0" label="Reschedule" class="ml-3" @click="btnReschedule"></gofix-button>
            </li>
            <li class="control-item control-item-prr" v-if="tableControls.massPrint || tableControls.updateWONumber">
              <b-dropdown class="btn" left v-b-tooltip.hover title="Option">
                <b-dropdown-item v-if="tableControls.massPrint" @click="massPrint">Mass Print</b-dropdown-item>
                <b-dropdown-item v-if="tableControls.updateWONumber" @click="updateWONumber">Update WO Number</b-dropdown-item>
                <slot name="gofix_table:after-control-custom-dropdown"></slot>
              </b-dropdown>
              <gofix-button :label="EndorsedDORJsStatus.label" outline @click="filtersEndorsedDORJsStatus"></gofix-button>
              <slot name="gofix_table:after-control-custom-prr"></slot>
            </li>
            <slot name="gofix_table:after-control-left"></slot>
            <slot name="gofix_table:after-control-left-selected" v-if="tableSelected.selected.length"></slot>
          </ul>
        </div>
      </b-col>
      <b-col :md="tableSettings.rightWidth">
        <div class="tableControls">
          <slot name="gofix_table:before-control-right"></slot>
          <div class="tableSelected" v-if="tableSelected.allSelected && tableControls.allItems && tableSettings.total > tableRequest.limit">
            <p class="mb-0">
              All {{tableSelected.allItems ? tableSettings.total : tableSelected.selected.length}} items on this page are selected<br />
              <span class="m0 m-0" @click="tableSelected.allItems = true" v-if="!tableSelected.allItems"> Select all {{tableSettings.total}} items</span>
            </p>
          </div>
          <div class="tableSendSelected mr-2" v-if="tableControls.reportPDF">
            <gofix-button :label="tableControls.titleReportPDF" @click="report" outline></gofix-button>
          </div>
          <div class="tableSendSelected mr-4" v-if="(this.constValue.controls.sendSelectedHidden && this.tableSelected.selected.length > 0 ) || (!this.constValue.controls.sendSelectedHidden && tableControls.sendSelected )">
            <gofix-button :label="tableControls.sendSelectedText" :disabled="tableControls.sendSelectedDisabled" @click="sendSelectedData" outline></gofix-button>
          </div>
          <div class="tablePagination" v-if="tableControls.tablePagination">
            <div class="pageCount min-width-95">
              {{tableSettings.total === 0 ? 0 : ((tableRequest.page - 1) * tableRequest.limit) + 1}} - {{(tableRequest.page * tableRequest.limit) > tableSettings.total ? tableSettings.total : (tableRequest.page * tableRequest.limit) }} of {{tableSettings.total}}
            </div>
            <div class="pageControls">
                            <span class="prev" @click="prevPage" title="Previous page" v-bind:class="{'disabled-button': tableRequest.page <= 1}" v-b-tooltip.hover>
                                <svg width="6" height="10" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.29344 0.293762C6.68344 0.683762 6.68344 1.31376 6.29344 1.70376L2.41344 5.58376L6.29344 9.46376C6.68344 9.85376 6.68344 10.4838 6.29344 10.8738C5.90344 11.2638 5.27344 11.2638 4.88344 10.8738L0.293437 6.28376C-0.0965624 5.89376 -0.0965624 5.26376 0.293437 4.87376L4.88344 0.283762C5.26344 -0.0962378 5.90344 -0.0962378 6.29344 0.293762Z" fill="black" fill-opacity="0.54"></path>
                                </svg>
                            </span>
              <span class="next" @click="nextPage" title="Next page" v-bind:class="{'disabled-button':tableRequest.page >= tableSettings.totalPage}" v-b-tooltip.hover>
                                <svg width="6" height="10" viewBox="0 0 5 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.2925 0.293762C-0.0975 0.683762 -0.0975 1.31376 0.2925 1.70376L4.1725 5.58376L0.2925 9.46376C-0.0975 9.85376 -0.0975 10.4838 0.2925 10.8738C0.6825 11.2638 1.3125 11.2638 1.7025 10.8738L6.2925 6.28376C6.6825 5.89376 6.6825 5.26376 6.2925 4.87376L1.7025 0.283762C1.3225 -0.0962378 0.6825 -0.0962378 0.2925 0.293762Z" fill="black" fill-opacity="0.54">
                                    </path>
                                </svg>
                            </span>
            </div>
            <div class="pageLimit">
              <gofix-form-dropdown
                  label=""
                  class="gofixInputMinWith gofixDropdownBorder gofixInputNoBg gofixDropdownLimit m-0"
                  :options="[25,50,100,150,200,500]"
                  :filterable="false"
                  :clearable="false"
                  :searchable="false"
                  v-model="tableRequest.limit"
              >
              </gofix-form-dropdown>
            </div>
          </div>
          <div class="tableFilter" v-bind:class="{active:actionStatus.showFilter}" v-if="tableControls.tableFilter">
                        <span class="filter" title="Filter" v-b-tooltip.hover @click="actionStatus.showFilter = !actionStatus.showFilter">
                            <svg width="21" height="13" viewBox="0 0 21 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.30512 13H12.7496V10.8333H8.30512V13ZM0.527344 0V2.16667H20.5273V0H0.527344ZM3.86068 7.58333H17.194V5.41667H3.86068V7.58333Z" fill="#999999"/>
                            </svg>
                        </span>
          </div>
          <div class="tableSettings" v-if="tableControls.tableImport || tableControls.tableExport || tableControls.tableExportCaseNLT || tableControls.tableColumnSettings">
            <b-dropdown right>
              <slot name="gofix_table:before-control-right-setting"></slot>
              <b-dropdown-item v-if="tableControls.tableImport" @click="actionStatus.modals.import.open = true">Import</b-dropdown-item>
              <slot name="gofix_table:before-control-right-setting-after-import"></slot>
              <b-dropdown-item v-if="tableControls.tableExport" @click="exportCsv" href="#">Export</b-dropdown-item>
              <b-dropdown-item v-if="tableControls.tableExportCaseNLT" @click="exportCaseNLT" href="#">Export Case NLT</b-dropdown-item>
              <b-dropdown-item v-if="tableControls.tableExportCustom" @click="exportCustom" href="#">{{ tableControls.tableExportCustomName }}</b-dropdown-item>
              <b-dropdown-item v-if="tableControls.tableColumnSettings" @click="actionStatus.modals.columnSetting.open = true" href="#">Column Setting</b-dropdown-item>
            </b-dropdown>
          </div>
          <slot name="gofix_table:after-control-right"></slot>
        </div>
      </b-col>
    </b-row>


    <vue-scrollbar class="tableList" v-bind:class="[{showFilter:actionStatus.showFilter}, {showGrid:showGrid}, {'fixed-scrollbar': isFixedScrollbar}]" ref="vueScrollbar">
      <slot v-if="this.showGrid" name="gofix_table:show-mold" v-bind="{ gridData: tableItems, tableSelected, actionStatus }"></slot>
      <b-table  v-if="!this.showGrid" :items="tableItems"
                :class="tableClass"
                :fields="tableShowFields"
                @head-clicked="tableHeaderClick"
                @row-clicked="tableItemRowClick" fixed
                :tbodyTrClass="tbodyTrClass"
      >

        <!-- Filter fields -->
        <template slot="top-row" slot-scope="row">
          <FilterTable :columns="row" :tableRequest="tableRequest" :filter="tableRequest.filter" :search="search" :data-select="tableSettings.dataSelect" :key="componentKey"></FilterTable>
        </template>

        <!--Header render-->
        <template :slot="'HEAD_' + field.key" v-if="field.key !== 'actions'" slot-scope="data" v-for="field in tableFields.show">
          {{data.label}}
          <span class="icon-sorting" v-if="field.sorting">
                    <i class="fa fa-caret-up icons font-xs" v-bind:class="{active : tableRequest.sortColumn === data.column && (tableRequest.sortDirection === 'DESC' || tableRequest.sortDirection.direction === 'DESC')}"></i>
                    <i class="fa fa-caret-down down icons font-xs" v-bind:class="{active : tableRequest.sortColumn === data.column && (tableRequest.sortDirection === 'ASC'  || tableRequest.sortDirection.direction === 'ASC')}"></i>
                </span>
        </template>

        <!--Slot custom table-->
        <template :slot="field.key" v-if="field.key !== 'actions'" slot-scope="data" v-for="field in tableFields.show">
          <slot :name="`gofix_table:${field.key}`" v-bind:item="data.item" v-bind:index="data.index">
            {{data.item | fieldVal(field.key)}}
          </slot>
        </template>

        <!-- Default checkbox -->

        <template v-if="!tableSettings.hideCheckbox" slot="HEAD_actions" slot-scope="foo">
          <b-form-checkbox :disabled="tableSettings.name === 'email-integration-list' || tableSettings.name === 'case-management-activity-logs' " class="uniform" v-model="tableSelected.allSelected" @change="selectAllItems"></b-form-checkbox>
        </template>
        <template v-if="!tableSettings.hideCheckbox" slot="actions" slot-scope="row">
          <slot name="gofix_table:before-actions" v-bind:item="row.item" v-bind:index="row.index"></slot>
          <slot name="gofix_table:actions" v-bind="row" >
            <b-form-checkbox v-if="['preventive-maintenance-property-schedule','email-integration-list','asset-management-asset-scheduling','joblist','case-management','case-list','payment-line-item-source', 'client-contract-listing', 'finance-navision-file-listing', 'finance-general-ledger', 'client-contract-service-category-fault-type', 'ap-invoice-listing', 'ap-invoice-line-items', 'misc-expenses-listing', 'part-replacement-history-asset-management-listing', 'part-replacement-history-equipment-listing', 'client-contract-equipment-history','case-management-activity-logs','table-incoming-documents'].indexOf(tableSettings.name) < 0" :value="row.item.id" v-model="tableSelected.selected"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'joblist'" :value="row.item.id" v-model="tableSelected.selected" :disabled="row.item.order_id != null"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'case-management'" :value="row.item.id" v-model="tableSelected.selected" :disabled="row.item.work_order_id != null || row.item.status == 'Closed'"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'payment-line-item-source'" :value="row.item.payment_voucher != null ? 0:row.item.id" v-model="tableSelected.selected" :disabled="row.item.payment_voucher != null"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'client-contract-listing'" :value="row.item.id" v-model="tableSelected.selected" :disabled="row.item.status == 'Active' || row.item.status == 'Reopening'"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'finance-navision-file-listing'" :value="row.item.id" v-model="tableSelected.selected" @click.native="changeValueInput(row.item.id,$event)"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'finance-general-ledger'" :value="row.item.id" v-model="tableSelected.selected" :disabled="row.item.posting_status != 'Pending' && row.item.posting_status != 'Draft'"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'table-incoming-documents'" :value="row.item.incoming_document_id" v-model="tableSelected.selected"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'client-contract-service-category-fault-type'" :value="row.item.id" v-model="tableSelected.selected" :disabled="row.item.service_category_id != tableRequest.service_category_id"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'asset-management-asset-scheduling'" :value="row.item" v-model="tableSelected.selected"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'preventive-maintenance-property-schedule'" :value="row.item" v-model="tableSelected.selected"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'ap-invoice-listing'" :value="row.item.id" v-model="tableSelected.selected"
                             :disabled="row.item.status != 'Draft'
                            && row.item.status != 'Pending Verification'
                            && row.item.status != 'Verified'
                            && row.item.status != 'Cancelled'">
            </b-form-checkbox>

            <b-form-checkbox v-if="tableSettings.name === 'email-integration-list' || tableSettings.name === 'case-list'" :value="row.item.id" v-model="tableSelected.single"
                            >
            </b-form-checkbox>

            <b-form-checkbox v-if="tableSettings.name === 'case-management-activity-logs'" :value="row.item.id" v-model="tableSelected.single" :disabled="row.item.status == 'Deleted'"></b-form-checkbox>



            <b-form-checkbox v-if="tableSettings.name === 'misc-expenses-listing'" :value="row.item.id" v-model="tableSelected.selected"
                             :disabled="row.item.status != 'Draft'
                            && row.item.status != 'Submitted'
                            && row.item.status != 'Cancelled'">
            </b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'ap-invoice-line-items'" :value="row.item.id" v-model="tableSelected.selected"
                             :disabled="apInvoice.status != 'Draft'
                            && apInvoice.status != 'Pending Verification'
                            && apInvoice.status != 'Verified'
                        "
            ></b-form-checkbox>
            <!-- <b-form-checkbox v-if="tableSettings.name === 'case-management-activity-logs'" :value="row.item.id" v-model="tableSelected.selected" :disabled="row.item.status == 'Deleted'"></b-form-checkbox> -->
            <template v-if="tableSettings.name === 'part-replacement-history-equipment-listing' ||
                        tableSettings.name === 'part-replacement-history-asset-management-listing'">
              <b-form-checkbox  :value="row.item" v-model="tableSelected.selected"></b-form-checkbox>
            </template>
            <b-form-checkbox v-if="tableSettings.name === 'client-contract-equipment-history'" :value="row.item.job_id" v-model="tableSelected.selected" :disabled="row.item.order_id != null || row.item.job_status == 'Expired'"></b-form-checkbox>
            <b-form-checkbox v-if="tableSettings.name === 'lmu-incoming-documents'" :value="row.item.incoming_document_id" v-model="tableSelected.selected"></b-form-checkbox>
          </slot>
        </template>

        <!-- bottom row -->
        <template slot="bottom-row" slot-scope="data">
          <slot :name="`gofix_table:bottom-row`" v-bind:data="data"></slot>
        </template>

      </b-table>
    </vue-scrollbar>

    <!--  --------------------------------  Modals HTML ------------------------------------   -->
    <!--Setting Columns-->
    <b-modal :no-close-on-backdrop="true" :id="actionStatus.modals.columnSetting.resizeColumn ? 'modal-Columns': 'modal-column-settings'"
             :title="actionStatus.modals.columnSetting.resizeColumn ? 'Column Width (px)' : 'Column Setting'"
             v-model="actionStatus.modals.columnSetting.open"
             hide-footer :centered="true"
             @hidden="resetColumnFieldsSetting"
    >

      <div v-bind:class="{'run-loading' : actionStatus.modals.columnSetting.loading}">
        <div v-if="actionStatus.modals.columnSetting.resizeColumn" class="columnsShow">
          <ul>
            <template v-for="(item, index) in tableFields._show">
              <li v-if="item.key !== 'actions'">
                <gofix-form-input-number
                    :label="item.label"
                    v-model="item.width"
                    :integer-limit="6"
                    :include-thousands-separator="false"
                    :allowDecimal="false"
                ></gofix-form-input-number>
              </li>
            </template>
          </ul>
        </div>
        <div v-if="!actionStatus.modals.columnSetting.resizeColumn" class=" resetAll columnsHide">
          <gofix-button label="Reset All" @click="resetDefault" outline></gofix-button>
        </div>

        <div v-if="!actionStatus.modals.columnSetting.resizeColumn" class="columnsShow">
          <ul>
            <draggable v-model="tableFields._show" >
              <template v-for="(item, index) in tableFields._show">
                <li v-if="item.key !== 'actions'">
                  <gofix-button :label="item.label" @click="hiddenField(item,index)">
                    <template slot="gofix:button:beforeLabel"><span class="closeIcon"></span></template>
                  </gofix-button>
                </li>
              </template>
            </draggable>
          </ul>
        </div>
        <div v-if="!actionStatus.modals.columnSetting.resizeColumn" class="columnsHide">
          <ul>
            <draggable v-model="tableFields._hide">
              <template v-for="(item,index) in tableFields._hide">
                <li>
                  <gofix-button :label="item.label" @click="shownField(item,index)" outline>
                    <template slot="gofix:button:beforeLabel"><span class="closeIcon"></span></template>
                  </gofix-button>
                </li>
              </template>
            </draggable>
          </ul>
        </div>

        <b-button-group class="d-block text-right pr-3">
          <gofix-button v-if="!actionStatus.modals.columnSetting.resizeColumn" label="EDIT COLUMN WIDTH" @click="linkToEditColumnWith" noBorder dark></gofix-button>
          <gofix-button v-else label="CANCEL" @click="resetColumnFieldsSetting" noBorder dark></gofix-button>
          <gofix-button :label="actionStatus.modals.columnSetting.resizeColumn ? 'APPLY' : 'SUBMIT'" @click="saveColumnSettingWithUser" noBorder></gofix-button>
        </b-button-group>
      </div>
    </b-modal>




    <!-- link A Case -->
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="actionStatus.modals.linkCase.open">
      <div class="center">Are you sure you want to<br/> <strong>Link A Case</strong>?</div>
      <b-button-group class="btn-group">
        <b-button class="custom-btn" @click="actionStatus.modals.linkCase.open = false">No</b-button>
        <b-button class="custom-btn" :disabled="actionStatus.modals.linkCase.loading" @click="createLinkCase" > <b-spinner v-if="actionStatus.modals.linkCase.loading" small type="grow"></b-spinner> Yes</b-button>
      </b-button-group>
    </b-modal>

    <!-- New Case -->
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="actionStatus.modals.newLinkcase.open">
      <div class="center">Are you sure you want to<br/> <strong>Link A New Case</strong>?</div>
      <b-button-group class="btn-group">
        <b-button class="custom-btn" @click="actionStatus.modals.newLinkcase.open = false">No</b-button>
        <b-button class="custom-btn" :disabled="actionStatus.modals.newLinkcase.loading" @click="createLinkNewCase" > <b-spinner v-if="actionStatus.modals.newLinkcase.loading" small type="grow"></b-spinner> Yes</b-button>
      </b-button-group>
    </b-modal>


    <!--Enable Comfirm-->
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="actionStatus.modals.createPWO.open">
      <div class="center">Are you sure you want to<br/>create <strong>PWO</strong>?</div>
      <b-button-group class="btn-group">
        <b-button class="custom-btn" @click="actionStatus.modals.createPWO.open = false">No</b-button>
        <b-button class="custom-btn" :disabled="actionStatus.modals.createPWO.loading" @click="createPWO" > <b-spinner v-if="actionStatus.modals.createPWO.loading" small type="grow"></b-spinner> Yes</b-button>
      </b-button-group>
    </b-modal>
    <!--Change Status-->
    <b-modal :no-close-on-backdrop="true" id="modalChangeStatus" title="Edit Status" hide-footer :centered="true" v-model="actionStatus.modals.changeStatus.open">
      <b-form class="pb-20"  v-bind:class="{'run-loading':actionStatus.modals.changeStatus.loading}">
        <b-row>
          <b-col md="12">
            <gofix-form-dropdown
                label="Choose Status"
                :filterable="false"
                :required="true"
                :vLabel="'text'"
                :reduce="option => option.value"
                v-model="actionStatus.modals.changeStatus.status"
                :options="actionStatus.modals.changeStatus.data">
            </gofix-form-dropdown>
          </b-col>
        </b-row>
      </b-form>
      <b-button-group class="d-block text-right">
        <gofix-button label="APPLY" @click="editStatusItems" :loading="actionStatus.modals.changeStatus.loading"  noBorder></gofix-button>
      </b-button-group>
    </b-modal>
    <!--Import data-->
    <b-modal :no-close-on-backdrop="true" @hide="resetImport" title="import file" id="modal-Import" hide-footer v-model="actionStatus.modals.import.open">
      <b-form>
        <slot name="gofix_table:before-import-modal"></slot>
        <b-form-group>
          <b-form-file @input="changeFile" placeholder="Click Browse to upload file" :state="actionStatus.modals.import.check" ref="file-input" accept=".csv" v-model="actionStatus.modals.import.file" >
            <template slot="file-name" slot-scope="{ names }">
              <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
            </template>
          </b-form-file>
        </b-form-group>
        <slot name="gofix_table:after-import-modal"></slot>
        <b-button-group class="d-block text-right">
          <gofix-button label="SUBMIT" @click="importItems" :loading="actionStatus.modals.import.loading"  noBorder></gofix-button>
        </b-button-group>
      </b-form>
    </b-modal>
    <!--Delete items-->
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" v-model="actionStatus.modals.delete.open">
      <div class="center" v-html="tableControls.modalTitleDelete"></div>
      <b-button-group class="btn-group">
        <b-button class="custom-btn" @click="actionStatus.modals.delete.open = false">No</b-button>
        <b-button class="custom-btn" @click="deleteTableItems" :disabled="actionStatus.modals.delete.loading">
          <b-spinner v-if="actionStatus.modals.delete.loading" small type="grow"></b-spinner>Yes
        </b-button>
      </b-button-group>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
const FilterTable = () => import('./filterDefaultTable')
import draggable from 'vuedraggable';
export default {
  name: 'newGofixTables',
  props: {
    settings: {
      type: Object,
      default: null
    },
    tableItems: {
      type: Array,
      default: []
    },
    columnSettingContractId:{
      default:null
    },
    showGrid: {
      type: Boolean,
      default: false
    },
    tableClass: {
      type: String,
      default: null
    },
    tbodyTrClass: {
      type: [String, Array, Function],
      default: null
    },
    columnWidthSetting:{
      type:Object,
      default:null
    },
    isFixedScrollbar:{
      type: Boolean,
      default: true
    }
  },
  components: {
    FilterTable,
    draggable
  },
  computed: {
    ...mapGetters({
      userLogged: "AuthController/user",
      contractSelector: 'ContractController/ClientContractID',
      apInvoice: 'ApInvoiceController/Item',
    }),
    tableShowFields: function() {
      let isPushAutoWidth = false;
      let obj = this.tableFields.show.find(item => item.thStyle === "width:auto");
      if(obj) isPushAutoWidth = true;

      let data = JSON.parse(JSON.stringify(this.tableFields.show));
      if(this.tableSettings.name == 'case-management') {
        let status = [{"value":"Open","text":"Open"},{"value":"Assigned","text":"Assigned"},{"value":"PIC Acknowledged","text":"PIC Acknowledged"},{"value":"On Site","text":"On Site"},{"value":"In Progress","text":"In Progress"},{"value":"RWO Issued","text":"RWO Issued"},{"value":"Completed","text":"Completed"},{"value":"Cancelled","text":"Cancelled"}];
        if(this.contractSelector && this.contractSelector.case_settings && this.contractSelector.case_settings.is_use_nlt_case_module) {
          status = [{"value":"Open","text":"Open"},{"value":"Replied to EU (FCR)","text":"Replied to EU (FCR)"},{"value":"Replied to EU (NFCR)","text":"Replied to EU (NFCR)"},{"value":"Replied to EU (Final NFCR)","text":"Replied to EU (Final NFCR)"},{"value":"Escalated","text":"Escalated"},{"value":"1st ST Reminder","text":"1st ST Reminder"},{"value":"2nd ST Reminder","text":"2nd ST Reminder"},{"value":"3rd ST Reminder","text":"3rd ST Reminder"},{"value":"4th ST Reminder","text":"4th ST Reminder"},{"value":"ST Replied","text":"ST Replied"},{"value":"ST No Response","text":"ST No Response"}];
        }
        if(this.$route.name && (this.$route.name == 'case-all' || this.$route.name == 'case-all-d')) status.push({"value":"Closed","text":"Closed"});
        if(this.$route.name && (this.$route.name == 'case-closed' || this.$route.name == 'case-closed-d')) status = [{"value":"Closed","text":"Closed"}];
        data.map(item => {
          if(item.key == 'status') {
            item.filter.data.value = status;
          }
        })
      }

      if(isPushAutoWidth) {
        data.push({
          alignment: null,
          default_sorting: 'off',
          filter: null,
          isActive: true,
          isFilter: false,
          key: "autowidth",
          label: "",
          sequence: data.length,
          sorting: false,
          thStyle: "width:auto",
          width: null,
        });
      }
      this.$emit("get-column-settings",data);
      this.$emit("get-all-column-settings", this.tableFields._show);
      return data;
    },
    tableControls: function () {
      if(this.tableSettings.name=="email-integration-list")
      {
        // this.constValue.controls.emailAssign=true;

        let user_roles=JSON.parse( localStorage.getItem('user_roles') ).data;
        let bol=false;
        for (let i = 0; i < user_roles.length; i++) {
          if(user_roles[i].roles['email management-assign email'].assign_email==1)
          {
            bol=true;
            break;
          }
        }


        this.constValue.controls.emailAssign = bol;


      }

      return  Object.assign({},this.constValue.controls, this.settings.controls);
    },
  },
  data: () => {
    return {
      constValue:{
        limit: [1,25,50,100,500],
        controls:{
          reload: true,
          create: true,
          createEmail:false,
          createTooptip: "New",
          createEmailTooltip: "New",
          disabled_create: false,
          delete: true,
          reply:false,
          caseStatus:'',
          resend:false,
          createPWO: false,
          linkCase: false,
          newLinkCase:false,
          markAsUnread:false,
          emailAssign:false,
          enable: false,
          disable: false,
          assign: false,
          changeStatus: false,
          allItems: false,
          adjustment: false,
          sendSelected: false,
          sendSelectedText: "Save",
          download: false,
          email_send: false,
          nav_file: false,
          tableFilter:true,
          tableImport:true,
          tableExport:true,
          tableExportCaseNLT:false,
          tableCloneMaster:false,
          tableCloneMasterIcon: 'img/clone.png',
          tableColumnSettings:true,
          tablePagination:true,
          modalTitleDelete: 'Are you sure you want to<br/>delete <strong>This Item</strong>?',
          sendSelectedHidden: false,
          sendSelectedDisabled: false,
          renameField: false,
          reportPDF: false,
          titleReportPDF: "Report PDF",
          btnReschedule: false,
          tableExportCustom: false,
          tableExportCustomName: null,
        },
        leftWidth: 3,
        rightWidth: 9
      },
      componentKey: 0,
      actionStatus:{
        showFilter: false,
        listLoading: false,
        modals: {
          columnSetting:{
            open: false,
            resizeColumn: false,
            loading: false
          },
          linkCase:{
            open: false,
            loading: false
          },
          newLinkcase:{
            open: false,
            loading: false
          },
          createPWO : {
            open: false,
            loading: false
          },
          changeStatus : {
            open: false,
            loading: false,
            status: null,
            //data: ["Planned","Due","Started","Completed","Verified","Expired","Cancelled"],
            data: [
              {value: 'Started', text: 'Started'},
              {value: 'Completed', text: 'Completed'},
            ]
          },
          import:{
            open: false,
            loading: false,
            file: null,
            fileName: "Click Browse to upload file"
          },
          delete: {
            open: false,
            loading: false
          },
          reply:{
            open: false,
            loading: false
          }
        }
      },
      tableSettings: {
        totalPage : 1,
        total : 0,
        leftWidth: 3,
        rightWidth: 9
      },
      tableFields: {
        fields : [],
        show : [],
        hide : [],
        _show : [],
        _hide : [],
      },
      tableRequest:{
        filter:null,
        limit:100,
        page:1,
        isCMS: 1,
        sortColumn: null,
        sortDirection: null,
        useDatabaseView: false
      },
      tableSelected : {
        single:null,
        allSelected : false,
        selected : [],
        allItems:false
      },
      isUpdateFieldNotSave: false,
      EndorsedDORJsStatus: {
        label: 'Endorsed DORJs',
        status: 0,
      },
    }
  },
  filters:{
    fieldVal: function(value,key) {
      if(!key) return '';
      let key_tmp = key.split(".");
      if(key_tmp.length > 1){
        let objData = value;
        for (let i = 0 ; i < key_tmp.length; i++){
          objData = (objData && objData[key_tmp[i]]) ? objData[key_tmp[i]] : null;
          if(objData === null) return null;
        }
        return objData;
      }
      return value[key];
    }
  },
  async created() {
    //Merge settings
    let tableSettings = Object.assign(this.tableSettings,this.settings);
    tableSettings.controls = Object.assign(this.constValue.controls,this.settings.controls);
    this.tableSettings = JSON.parse(JSON.stringify(tableSettings));
    this.tableSettings.totalPage = Math.ceil(this.tableSettings.total / this.tableRequest.limit);
    if(this.columnWidthSetting){
      this.tableSettings.leftWidth = this.columnWidthSetting.leftWidth;
      this.tableSettings.rightWidth = this.columnWidthSetting.rightWidth;
    }
    //Merge filter
    this.tableRequest.filter = JSON.parse(JSON.stringify(this.settings.filter));
    this.setFilterToContractID()

    //Merge sorting
    this.tableRequest.sortColumn = this.settings.sortColumn || null;
    this.tableRequest.sortDirection = this.settings.sortDirection ? this.settings.sortDirection.toUpperCase() : null;

    //Merge use Database view
    this.tableRequest.useDatabaseView = this.settings.useDatabaseView || null;

    //Load table config by user
    await this.getColumnSettingByUser();
    //Get table data
    await this.getTableData(true);
  },
  watch:{
    userLogged: async function(val, old) {
      if(val && val.id) {
        await this.getColumnSettingByUser();
        await this.getTableData(true);
      }
    },
    contractSelector: function(val, old) {
      if(this.tableRequest.filter.hasOwnProperty('contract_id') || this.tableRequest.filter.hasOwnProperty('client_contract_id') || this.tableRequest.filter.hasOwnProperty('contract_term_id')){
        this.reloadTableItems();
      }
      if(this.columnSettingContractId){
        this.getColumnSettingByUser();
      }

      this.EndorsedDORJsStatus.label = 'Endorsed DORJs'
      this.EndorsedDORJsStatus.status = 0
    },
    "settings.total" : function(val){
      this.tableSettings.total = val;
      this.tableSettings.totalPage =  Math.ceil(val/ this.tableRequest.limit)
    },
    "settings.itemSelected" : function(val){
      this.tableSelected.selected = val;
    },
    "tableRequest.page" : function(val){
      this.tableSelected.selected = [];
      this.tableSelected.allSelected = false;
      this.getTableData();
    },
    "tableRequest.limit" : function(val){
      if(this.tableRequest.page === 1){
        this.getTableData();
      }else{
        this.tableRequest.page = 1;
      }
    },
    "tableSelected.allSelected": function(val, old) {
      this.tableSelected.allItems = false;
    },
    "tableSelected.selected": function(val, old) {

      if(this.isReload)  {
        this.isReload = false
        return this.allSelected = false;
      }
      //let arr = this.Items.data.filter(item => item.order_id == null)
      if(this.tableSelected.selected.length > 0 && this.tableItems.length === this.tableSelected.selected.length) {
        this.tableSelected.allSelected = true;
      }else{
        this.tableSelected.allSelected = false;
      }

      this.$emit('change-selected', val);
    },
    "tableSelected.single": function(val, old) {
      if(this.isReload)  {
        this.isReload = false
        return this.allSelected = false;
      }
      //let arr = this.Items.data.filter(item => item.order_id == null)
      if(this.tableSelected.selected.length > 0 && this.tableItems.length === this.tableSelected.selected.length) {
      this.tableSelected.allSelected = true;
      }else{
        this.tableSelected.allSelected = false;
      }

      this.$emit('change-selected', val);
    },
    "actionStatus.modals.import.file": function(val, old) {
      if (val) {
        let arrExtionsionAccept = ['csv']
        let split = val.name.split('.');
        let extension = split[split.length - 1].toLowerCase();
        if(!arrExtionsionAccept.includes(extension)) {
          this.$refs['file-input'].reset();
          return this.$alertNotification("File format is incorrect. Please select a .csv file!", "primary");
        }
        return this.actionStatus.modals.import.fileName = val.name;
      }
      return this.actionStatus.modals.import.fileName = 'Click Browse to upload file'
    },
    "tableSettings.name": function(val) {
      this.getColumnSettingByUser();
    }
  },
  methods:{
    changeValueInput(value, event) {
      if(this.tableSettings.name == 'finance-navision-file-listing') {
        if (event.target.tagName === 'INPUT') {
          let itemSelected = this.tableItems.filter(item => item.id == value);
          if(itemSelected.length) {
            let nameSearch = itemSelected[0].file_name.split(' ');
            let itemCheckTogether = this.tableItems.filter(item => item.file_name.indexOf(nameSearch[0]) != -1 && item.id != value);
            if(itemCheckTogether.length) {
              if (!event.target.checked) {
                this.tableSelected.selected = this.tableSelected.selected.filter(item => item != itemCheckTogether[0].id);
                if(this.tableSelected.selected.includes(value)) this.tableSelected.selected = this.tableSelected.selected.filter(item => item != value);
              } else {
                if(!this.tableSelected.selected.includes(value)) this.tableSelected.selected.push(value);
                this.tableSelected.selected.push(itemCheckTogether[0].id);
              }
            }
          }
        }
      }
    },
    updateDataSelect(){
      this.tableSettings.dataSelect = Object.assign(this.tableSettings.dataSelect, this.settings.dataSelect)
      this.getColumnSettingByUser();
    },
    updateDeletedBT(){
      this.tableSettings.controls.delete = this.settings.controls.delete
    },
    updateCreateBT(){
      this.tableSettings.controls.create = this.settings.controls.create
    },
    search(){
      if(this.tableSettings.name) {
        if(!["client-contract-approval-route", "finance-activity-log", "table-purging"].includes(this.tableSettings.name)) {
          let values = {};
          for (const [key, val] of Object.entries(this.tableRequest.filter)) {
            if (val &&
                !['client_contract_id', 'contract_id', 'work_item_id', 'work_item_type', 'folder_id', 'contract_term_id'].includes(key)
                && val.type && val.function && (
                  (Array.isArray(val.value) && val.value.length) || (!Array.isArray(val.value) && val.value)
                )
              ) {
                values[key] = {
                  function: val.function,
                  value: val.value,
                }
              }
          }

          

          if(this.tableSettings.name=="email-integration-list" && Object.keys(values).length == 0) {
          
          let assign_status = {"assign_status":{"function":"=","value":[]}}

            localStorage.setItem(this.tableSettings.name,JSON.stringify(assign_status));


          }else{
            if(Object.keys(values).length) localStorage.setItem(this.tableSettings.name, JSON.stringify(values));
            else localStorage.removeItem(this.tableSettings.name);
          }
        }
      }
      

      if(this.tableRequest.page === 1){
        this.getTableData();
      }else{
        this.tableRequest.page = 1;
      }
    },
    periodFilterComfirm() {
      this.$emit("period-filter", this.tableRequest.filter);
    },
    async getTableData(is_load_filter = false){
      if(this.userLogged.id) {
        this.actionStatus.listLoading = true;
        if(is_load_filter && localStorage.getItem(this.tableSettings.name)) {
          var filter = JSON.parse(localStorage.getItem(this.tableSettings.name));

        if(this.tableSettings.name == "preventive-maintenance-job-list-all" && filter['job_status'] && typeof filter['job_status'].value == "string" && filter['job_status'] != this.tableRequest.filter.job_status.value) {
          filter = {}
          localStorage.removeItem("preventive-maintenance-job-list-all");
        }

        if(Object.keys(filter).length) {
          for (const [key, val] of Object.entries(filter)) {
            if(this.tableRequest.filter[key]) {
              this.tableRequest.filter[key].function = val.function
              this.tableRequest.filter[key].value    = val.value
            }
          }
          this.actionStatus.showFilter = true;
        }
      }

      if(is_load_filter && localStorage.getItem(`${this.tableSettings.name}-sort`)) {
        var sort = JSON.parse(localStorage.getItem(`${this.tableSettings.name}-sort`));
        if(sort && sort.column && sort.direction) {
          this.tableRequest.sortColumn    = sort.column
          this.tableRequest.sortDirection = sort.direction
        }
      }

      new Promise((resolve, reject) => {
        let contract = localStorage.getItem("ClientContractID")
        if(this.tableSettings.name != 'table-purging' && 
          ((contract !== undefined && contract !== 'null' && contract !== '' && contract !== null && this.contractSelector != null) &&
          (
            (this.tableRequest.filter.hasOwnProperty('contract_id') && ((this.tableRequest.filter.contract_id.hasOwnProperty('value') && !this.tableRequest.filter.contract_id.value) || !this.tableRequest.filter.contract_id))
            || (this.tableRequest.filter.hasOwnProperty('client_contract_id') && ((this.tableRequest.filter.client_contract_id.hasOwnProperty('value') && !this.tableRequest.filter.client_contract_id.value) || !this.tableRequest.filter.client_contract_id))
            || (this.tableRequest.filter.hasOwnProperty('contract_term_id') && ((this.tableRequest.filter.contract_term_id.hasOwnProperty('value') && !this.tableRequest.filter.contract_term_id.value) || !this.tableRequest.filter.contract_term_id))
          ))
        ) {
          return
        }
        this.$emit('load-items', async () => {
          try {
            return {
              tableRequest: this.tableRequest,
              actionStatus: this.actionStatus,
              resolve,
              reject,
            }
          } catch (e) {
            reject(e)
          }
        })
      })
          .then(data => {
            this.tableSettings.total = data.total;
            this.tableSettings.totalPage =  Math.ceil(this.tableSettings.total/ this.tableRequest.limit);
            this.actionStatus.listLoading = false;
          })
          .catch(err => {
            this.actionStatus.listLoading = false;
          });
        }
    },
    //--------------------------------------------
    forceRerender() {
      this.componentKey += 1;
    },
    selectAllItems(val){
      if (val) {
        this.tableSelected.selected = [];
        for (let i in this.tableItems) {
          switch (this.tableSettings.name) {
            case "joblist":
              if(this.tableItems[i].order_id == null){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            case "case-management":
              if(!this.tableItems[i].work_order_id && this.tableItems[i].status !== 'Closed'){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            case "client-contract-listing":
              if(this.tableItems[i].status != "Active" && this.tableItems[i].status != "Reopening"){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            case "client-contract-service-category-fault-type":
              if(this.tableItems[i].service_category_id == this.tableRequest.service_category_id){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            case "table-incoming-documents":
              if(this.tableItems[i].incoming_document_id == this.tableRequest.incoming_document_id){
                this.tableSelected.selected.push(this.tableItems[i].incoming_document_id)
              }
              break;
            case "finance-general-ledger":
              if(this.tableItems[i].posting_status == 'Pending' || this.tableItems[i].posting_status == 'Draft'){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            case "ap-invoice-line-items":
              if(
                  this.apInvoice.status == 'Draft'
                  || this.apInvoice.status == 'Pending Verification'
                  || this.apInvoice.status == 'Verified'
              ){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            case "finance-navision-file-listing":
              if(this.tableItems[i].status !== "Posted"){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            case "payment-voucher-listing":
            case "ap-invoice-listing":
              if(
                  this.tableItems[i].status == 'Draft'
                  || this.tableItems[i].status == 'Pending Verification'
                  || this.tableItems[i].status == 'Verified'
                  || this.tableItems[i].status == 'Cancelled'
              ){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            case "misc-expenses-listing":
              if(
                  this.tableItems[i].status == 'Draft'
                  || this.tableItems[i].status == 'Cancelled'
                  || this.tableItems[i].status == 'Submitted'
              ){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            case "part-replacement-history-equipment-listing":
            case "part-replacement-history-asset-management-listing":
              this.tableSelected.selected.push(this.tableItems[i])
              break;
            case "client-contract-equipment-history":
              if(!this.tableItems[i].order_id && this.tableItems[i].job_status != 'Expired')
                this.tableSelected.selected.push(this.tableItems[i].job_id)
              break;
            case "asset-management-asset-scheduling":
              this.tableSelected.selected.push(this.tableItems[i])
              break;
            case "case-management-activity-logs":
              if(this.tableItems[i].status != 'Deleted'){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            case "lmu-incoming-documents":
              this.tableSelected.selected.push(this.tableItems[i].incoming_document_id)
              break;
            case "case-hot-button-listing":
              if(this.tableItems[i].status != 'Closed'){
                this.tableSelected.selected.push(this.tableItems[i].id)
              }
              break;
            default:
              this.tableSelected.selected.push(this.tableItems[i].id)
              break;
          }
        }
      }
      else {
        this.tableSelected.selected = [];
      }
    },
    prevPage(){
      if(this.tableRequest.page > 1){
        this.tableRequest.page += -1;
      }
    },
    nextPage(){
      if(this.tableRequest.page < this.tableSettings.totalPage){
        this.tableRequest.page += 1;
      }
    },
    //---------------------------------------------

    // Table events ---------------------------------------------
    tableItemRowClick(item,index,event){
      if(event.target.className.includes("no-edit") || event.target.parentElement.className.includes("no-edit")){
        return;
      }
      this.$emit("row-click",item,event);
    },
    tableHeaderClick(key,field){
      if(!field.sorting) return;
      if(field.is_customfield){
        if(field.attribute_id){
          if(this.tableRequest.sortColumn === key){
            if(this.tableRequest.sortDirection && this.tableRequest.sortDirection.direction === "ASC"){
              this.tableRequest.sortDirection = {
                attribute_id : field.attribute_id,
                direction : "DESC"
              };
            }else{
              this.tableRequest.sortDirection = {
                attribute_id : field.attribute_id,
                direction : "ASC"
              };
            }
          }else{
            this.tableRequest.sortColumn = key;
            this.tableRequest.sortDirection = {
              attribute_id : field.attribute_id,
              direction : "ASC"
            };
          }
        }else{
          return;
        }
      }else{
        if(this.tableRequest.sortColumn === key){
          if(this.tableRequest.sortDirection === "ASC"){
            this.tableRequest.sortDirection = "DESC";
          }else{
            this.tableRequest.sortDirection = "ASC";
          }
        }else{
          this.tableRequest.sortColumn = key;
          this.tableRequest.sortDirection = "ASC";
        }
      }

      if(this.tableSettings.name) {
        localStorage.setItem(`${this.tableSettings.name}-sort`, JSON.stringify({
          column: this.tableRequest.sortColumn,
          direction: this.tableRequest.sortDirection
        }));
      }
      this.getTableData(true);
    },
    reloadTableItems(){
      this.tableRequest.filter = JSON.parse(JSON.stringify(this.settings.filter));
      this.setFilterToContractID()

      //this.tableSettings.total = 0;
      this.tableRequest.page  = 1;

      this.tableSelected.allSelected = false;
      this.tableSelected.selected = [];
      localStorage.removeItem(this.tableSettings.name);
      localStorage.removeItem(`${this.tableSettings.name}-sort`);
      this.getTableData();
      this.$emit("reload-items");
    },
    reloadTableKeepFilter(){
      this.tableRequest.page  = 1;

      this.tableSelected.allSelected = false;
      this.tableSelected.selected = [];
      this.getTableData();
      this.$emit("reload-items");
    },
    createNewTableItem(){
      if(this.tableSettings.controls.disabled_create) return;
      this.$emit("new-item");
    },
    createNewTableEmailItem(){
      if(this.tableSettings.controls.disabled_create) return;
      this.$emit("new-email-item");
    },
    cloneMaster(){
      this.$emit("clone-master");
    },
    exportCsv(){
      this.$emit("export", this.tableRequest);
    },
    exportCaseNLT(){
      this.$emit("exportCaseNLT", this.tableRequest);
    },
    exportCustom(){
      this.$emit("exportCustom", this.tableRequest);
    },
    deleteTableItemsComfirm(){
      if(this.tableSelected.selected.length||this.tableSelected.single){
        this.actionStatus.modals.delete.open = true;
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    deleteTableItems(){
      if(this.actionStatus.modals.delete.loading) return;
      this.actionStatus.modals.delete.loading = true;
      new Promise((resolve, reject) => {
        this.$emit('delete-items', async () => {
          try {
            return {
              ids: this.tableSelected.selected.length==0 ? [this.tableSelected.single] : this.tableSelected.selected,
              filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
              resolve,
              reject,
            }
          } catch (e) {
            reject(e)
          }
        })
      })
          .then(data => {
            this.tableSelected.single=null;
            this.actionStatus.modals.delete.open = false;
            this.actionStatus.modals.delete.loading = false;
            if(data) {
              this.reloadTableKeepFilter();
              this.$alertNotification(data);
            }
          })
          .catch(err => {
            this.actionStatus.modals.delete.loading = false;
            return this.$alertNotification("Can't delete items!", "danger");
          })
      ;
    },
    createPWOComfirm(){
      if(this.tableSelected.selected.length){
        this.actionStatus.modals.createPWO.open = true;
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    createNewLinkCaseConfirm()
    {
      if(!!this.tableSelected.single ){
        this.actionStatus.modals.newLinkcase.open = true;
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    uncheckedRow()
    {
      this.tableSelected.single=null;
    },
    resendEmail()
    {
      new Promise((resolve, reject) => {
        this.$emit('resend-email', async () => {
          try {
            return {
              ids: this.tableSelected.single,
              filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
              resolve,
              reject,
            }
          } catch (e) {
            reject(e)
          }
        })
      })
          .then(data => {
            if(data) {
              this.reloadTableKeepFilter();
              this.$alertNotification(data);
            }
          })
          .catch(err => {
             this.$alertNotification("Can't send the case!", "danger");
          })
    },
    createLinkNewCase()
    {
      this.actionStatus.modals.newLinkcase.open=false;
      if(this.tableSettings.controls.disabled_create) return;


      new Promise((resolve, reject) => {
        this.$emit('new-case', async () => {
          try {
            return {
              ids: this.tableSelected.single,
              filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
              resolve,
              reject,
            }
          } catch (e) {
            reject(e)
          }
        })
      })
          .then(data => {
            if(data) {
              this.reloadTableKeepFilter();
              this.$alertNotification(data);
            }
          })
          .catch(err => {
             this.$alertNotification("Can't link case!", "danger");
          })
      // this.$emit("link-case");
    },

    createLinkCaseConfirm(){
      if(!!this.tableSelected.single ){
        this.actionStatus.modals.linkCase.open = true;
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    replyConfirm(){
      if(!!this.tableSelected.single ){

        
        let itemSelected = this.tableItems.filter(item => item.id == this.tableSelected.single);

        if(itemSelected[0].email_id)
        {
          new Promise((resolve, reject) => {
            this.$emit('reply-item', async () => {
              try {
                return {
                  ids: this.tableSelected.single,
                  filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
                  resolve,
                  reject,
                }
              } catch (e) {
                reject(e)
              }
            })
          })
          .then(data => {
                if(data) {
                  this.reloadTableKeepFilter();
                  this.$alertNotification(data);
                }
              })
          .catch(err => {
                this.$alertNotification("Can't link case!", "danger");
          })

        }else
        {
            this.$alertNotification("Please select Email Related Activity", "warning");
        }




          // end of promise
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },

    createLinkCase()
    {
      this.actionStatus.modals.linkCase.open=false;
      if(this.tableSettings.controls.disabled_create) return;


      new Promise((resolve, reject) => {
        this.$emit('link-case', async () => {
          try {
            return {
              ids: this.tableSelected.single,
              filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
              resolve,
              reject,
            }
          } catch (e) {
            reject(e)
          }
        })
      })
          .then(data => {
            if(data) {
              this.reloadTableKeepFilter();
              this.$alertNotification(data);
            }
          })
          .catch(err => {
             this.$alertNotification("Can't link case!", "danger");
          })
      // this.$emit("link-case");
    },
    createEmailAssign()
    {
       new Promise((resolve, reject) => {
        this.$emit('email-assign', async () => {
          try {
            return {
              ids: this.tableSelected.single,
              filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
              resolve,
              reject,
            }
          } catch (e) {
            reject(e)
          }
        })
      })
          .then(data => {
            if(data) {
              this.reloadTableKeepFilter();
              this.$alertNotification(data);
            }
          })
          .catch(err => {
             this.$alertNotification("Can't link case!", "danger");
          })
    },
    markAsUnread()
    {
      new Promise((resolve, reject) => {
        this.$emit('mark-as-unread', async () => {
          try {
            return {
              selected: this.tableSelected,
              ids: this.tableSelected.single,
              filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
              resolve,
              reject,
            }
          } catch (e) {
            reject(e)
          }
        })
      })
          .then(data => {
            if(data) {
              this.reloadTableKeepFilter();
              this.$alertNotification(data);
            }
          })
          .catch(err => {
             this.$alertNotification("Can't link case!", "danger");
          })

    },

    createPWO(){
      this.actionStatus.modals.createPWO.loading = true;
      new Promise((resolve, reject) => {
        this.$emit('create-pwo', async () => {
          try {
            return {
              ids: this.tableSelected.selected,
              filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
              resolve,
              reject,
            }
          } catch (e) {
            reject(e)
          }
        })
      })
          .then(data => {
            this.reloadTableItems();
            this.actionStatus.modals.createPWO.open = false;
            this.actionStatus.modals.createPWO.loading = false;
          })
          .catch(err => {
            this.actionStatus.modals.createPWO.loading = false;
          })
      ;

    },
    enableItems(){
      if(this.tableSelected.selected.length){
        this.$emit("enable-items",this.tableSelected.selected);
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    disableItems(){
      if(this.tableSelected.selected.length){
        this.$emit("disable-items",this.tableSelected.selected);
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    adjustmentItems(){
      if(this.tableSelected.selected.length){
        let filter = this.tableSelected.allItems ? JSON.stringify(this.tableRequest.filter) : null;
        this.$emit("adjustment-items",this.tableSelected.selected,filter);
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    downloadItems(){
      if(this.tableSelected.selected.length){
        let filter = this.tableSelected.allItems ? JSON.stringify(this.tableRequest.filter) : null;
        this.$emit("download-items", this.tableSelected.selected);
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    emailSendItems(){
      if(this.tableSelected.selected.length){
        let filter = this.tableSelected.allItems ? JSON.stringify(this.tableRequest.filter) : null;
        this.$emit("email-send-items", this.tableSelected.selected);
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    navFileItems(){
      this.$emit("nav-file-items");
    },
    assignItems(){
      if(this.tableSelected.selected.length){
        let filter = this.tableSelected.allItems ? JSON.stringify(this.tableRequest.filter) : null;
        this.$emit('assign-items',this.tableSelected.selected,filter);
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    editStatusItemsComfirm(){
      if(this.tableSelected.selected.length){
        this.actionStatus.modals.changeStatus.open = true;
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    editStatusItems(){
      if(this.actionStatus.modals.changeStatus.status){
        this.actionStatus.modals.changeStatus.open = true;
        this.actionStatus.modals.changeStatus.loading = true;
        new Promise((resolve, reject) => {
          this.$emit('edit-status-items', async () => {
            try {
              return {
                ids: this.tableSelected.selected,
                status: this.actionStatus.modals.changeStatus.status,
                filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
                resolve,
                reject,
              }
            } catch (e) {
              reject(e)
            }
          })
        })
            .then( data => {
              this.actionStatus.modals.changeStatus.open = false;
              this.actionStatus.modals.changeStatus.loading = false;
              this.reloadTableItems();
            })
            .catch(err => {
              this.actionStatus.modals.changeStatus.loading = false;
            })
        ;
      }else{
        this.$alertNotification("Please select a status", "warning");
      }
    },
    openImportModal(){
      this.actionStatus.modals.import.open = true;
    },
    importItems(){
      if(this.actionStatus.modals.import.loading) return ;
      if (!this.actionStatus.modals.import.file) {
        return this.$alertNotification("Please choose file to import", "danger");
      }
      this.actionStatus.modals.import.loading = true;
      new Promise((resolve, reject) => {
        this.$emit('import-items', async () => {
          try {
            return {
              file: this.actionStatus.modals.import.file,
              resolve,
              reject,
            }
          } catch (e) {
            reject(e)
          }
        })
      })
          .then( data => {
            this.actionStatus.modals.import.open = false;
            this.actionStatus.modals.import.loading = false;
            this.reloadTableItems();
          })
          .catch(err => {
            this.actionStatus.modals.import.loading = false;
            let msg = "Can't import data!";
            if( err.response.data.error
                && err.response.data.error.message
            ) {
              msg = err.response.data.error.message;
            }
            return this.$alertNotification(msg, "danger");
          });
    },
    sendSelectedData(){
      let filter = this.tableSelected.allItems ? JSON.stringify(this.tableRequest.filter) : null;
      this.$emit("get-selected",this.tableSelected.selected,filter);
    },
    report() {
      this.$emit("report");
    },
    // Settings columns ---------------------------------------------
    async getColumnSettingByUser(){
      if(this.userLogged.id) {
        if(this.tableSettings.name=='email-integration-list')
        {
          this.getemailIntegrationColumnSettings();
          return;
        }
        await this.$store.dispatch('AuthController/getNewColumnSettingsTableUser', {
          user_id: this.userLogged.id,
          table_name: this.tableSettings.name,
          contract_id: this.columnSettingContractId,
        }).then(response => {
          if(response.data.data.code && response.data.data.code == 404) {
            return;
          }

          var columnSettings = response.data.data;

          if(!columnSettings.user_id){
            // convert with dataselect
            columnSettings.settings.fields.forEach((obj) => {
              if(this.tableSettings.dataSelect && this.tableSettings.dataSelect[obj.key]){
                // set filter collection from dataSelect
                obj.filter.data = this.tableSettings.dataSelect[obj.key]
              }
            })
            // debugger
            // end

            var tmpShow =  columnSettings.settings.fields.filter(item => item.isActive == 1).sort((a,b) => a.sequence > b.sequence)

            tmpShow.forEach((obj) => {
              if(obj.default_sorting != 'off'){
                this.tableSettings.sortColumn = this.tableRequest.sortColumn = obj.key;
                this.tableSettings.sortDirection = this.tableRequest.sortDirection = obj.default_sorting.toUpperCase()
                // to do set default sorting
              }

              // set filter
              if(obj.filter.active){
                obj.isFilter = true
              }else{
                obj.isFilter = false
              }
            })

            var tmpHide = columnSettings.settings.fields.filter(item => item.isActive == 0).sort((a,b) => a.sequence > b.sequence)

            tmpHide.forEach((obj) => {
              // set filter
              if(obj.filter.active){
                obj.isFilter = true
              }else{
                obj.isFilter = false
              }
            })
            if( this.constValue.controls.renameField) {
              tmpShow = this.settings.fields;
            }


            this.tableFields.fields = tmpShow
            this.tableFields.show = tmpShow;
            this.tableFields.hide = tmpHide;
            this.tableFields._show = JSON.parse(JSON.stringify(this.tableFields.show));
            this.tableFields._hide = JSON.parse(JSON.stringify(this.tableFields.hide));
          }else{
            var tmpShow = response.data.data.settings.show;
            if(this.tableSettings.name == 'account-users') {
              columnSettings.settings.show.forEach((obj) => {
                if(this.tableSettings.dataSelect && this.tableSettings.dataSelect[obj.key]){
                  // set filter collection from dataSelect
                  obj.filter.data = this.tableSettings.dataSelect[obj.key]
                }
              })
              tmpShow =  columnSettings.settings.show.filter(item => item.isActive == 1).sort((a,b) => a.sequence > b.sequence)
            }

            this.tableFields.show = tmpShow;
            // this.tableFields.show = response.data.data.settings.show;
            this.tableFields.hide = response.data.data.settings.hide;
            this.tableFields._show = JSON.parse(JSON.stringify(this.tableFields.show));
            this.tableFields._hide = JSON.parse(JSON.stringify(this.tableFields.hide));
          }

          if(this.settings.buildFilter){
            // this.tableFields.hide
            this.buildFilterObject(this.tableFields.show,[]);
          }


        }).catch(error => {
          /*this.tableFields.show = JSON.parse(JSON.stringify(this.settings.fields));
          this.tableFields.hide = [];
          this.tableFields._show = JSON.parse(JSON.stringify(this.settings.fields));
          this.tableFields._hide = [];*/
        })
      }
    },
    getemailIntegrationColumnSettings(){
      this.$store.dispatch('AuthController/getNewColumnSettingsTableUser', {
            user_id: this.userLogged.id,
            table_name: this.tableSettings.name,
            contract_id: this.columnSettingContractId,
          }).then(async response => {
            
            if(response.data.data.code && response.data.data.code == 404) {
              return;
            }

            let columnSettings = response.data.data;
            
            columnSettings = await this.updatePersonInCharge(columnSettings);            
            
            if(!columnSettings.user_id){
              // convert with dataselect
              columnSettings.settings.fields.forEach((obj) => {
                if(this.tableSettings.dataSelect && this.tableSettings.dataSelect[obj.key]){
                  // set filter collection from dataSelect
                  obj.filter.data = this.tableSettings.dataSelect[obj.key]
                }
              })
              // debugger
              // end

              var tmpShow =  columnSettings.settings.fields.filter(item => item.isActive == 1).sort((a,b) => a.sequence > b.sequence)

              tmpShow.forEach((obj) => {
                if(obj.default_sorting != 'off'){
                  this.tableSettings.sortColumn = obj.key;
                  this.tableSettings.sortDirection = obj.default_sorting
                  // to do set default sorting
                }

                // set filter
                if(obj.filter.active){
                  obj.isFilter = true
                }else{
                  obj.isFilter = false
                }

              })

              var tmpHide = columnSettings.settings.fields.filter(item => item.isActive == 0).sort((a,b) => a.sequence > b.sequence)

              tmpHide.forEach((obj) => {
                // set filter
                if(obj.filter.active){
                  obj.isFilter = true
                }else{
                  obj.isFilter = false
                }
              })
              if( this.constValue.controls.renameField) {
                tmpShow = this.settings.fields;
              }


              this.tableFields.fields = tmpShow
              this.tableFields.show = tmpShow;
              this.tableFields.hide = tmpHide;
              this.tableFields._show = JSON.parse(JSON.stringify(this.tableFields.show));
              this.tableFields._hide = JSON.parse(JSON.stringify(this.tableFields.hide));
            }else{
              this.tableFields.show = response.data.data.settings.show;
              this.tableFields.hide = response.data.data.settings.hide;
              this.tableFields._show = JSON.parse(JSON.stringify(this.tableFields.show));
              this.tableFields._hide = JSON.parse(JSON.stringify(this.tableFields.hide));
            }

            if(this.settings.buildFilter){
              // this.tableFields.hide
              this.buildFilterObject(this.tableFields.show,[]);
            }


          }).catch(error => {
            /*this.tableFields.show = JSON.parse(JSON.stringify(this.settings.fields));
            this.tableFields.hide = [];
            this.tableFields._show = JSON.parse(JSON.stringify(this.settings.fields));
            this.tableFields._hide = [];*/
          })
    },
    updatePersonInCharge(columnSettings){
      this.$store.dispatch('UserDutyController/getUserItemsByRole', {
            name: 'being_assign_email',
            contract_id: this.contractSelector?this.contractSelector.id:null,
          })
      .then(async response => {
        
        if( columnSettings.settings.fields.length > 0 )
        {
          if(columnSettings.settings.fields.find(o => o.key === 'person_in_charge_id') !== 'null')
          {
            columnSettings.settings.fields.find(o => o.key === 'person_in_charge_id').filter.data.value = response;
          }
        }
        if (columnSettings.settings.show !== undefined) {
          if(columnSettings.settings.fields.find(o => o.key === 'person_in_charge_id') !== 'null')
          {
          columnSettings.settings.show.find(o => o.key === 'person_in_charge_id').filter.data.value = response;
          }
        }
      });

      this.$store.dispatch('UserDutyController/getUserItemsByRole', {
            name: 'assign_email',
            contract_id: this.contractSelector?this.contractSelector.id:null,
          })
      .then(async response => {

        if( columnSettings.settings.fields.length > 0 )
        {
          if(columnSettings.settings.fields.find(o => o.key === 'assigned_by') !== 'null')
          {
            columnSettings.settings.fields.find(o => o.key === 'assigned_by').filter.data.value = response;
          }
        }
        if (columnSettings.settings.show !== undefined) {
          if(columnSettings.settings.fields.find(o => o.key === 'assigned_by') !== 'null')
          {
          columnSettings.settings.show.find(o => o.key === 'assigned_by').filter.data.value = response;
          }
        }

        
      });
    
      return columnSettings;
    },
    resetColumnFieldsSetting(){
      if(!this.isUpdateFieldNotSave)
        this.tableFields._show = JSON.parse(JSON.stringify(this.tableFields.show));

      this.tableFields._hide = JSON.parse(JSON.stringify(this.tableFields.hide));
      this.actionStatus.modals.columnSetting.resizeColumn = false;
    },
    hiddenField(item,index){
      item.isActive = 0;
      this.tableFields._hide.push(item);
      this.tableFields._show.splice(index,1);
    },
    shownField(item,index){
      item.isActive = 1;
      this.tableFields._show.push(item);
      this.tableFields._hide.splice(index,1);
    },
    linkToEditColumnWith(){
      this.resetColumnFieldsSetting();
      this.actionStatus.modals.columnSetting.resizeColumn = true;
    },
    resetDefault(){
      this.$store.dispatch('AuthController/resetDefaultColumnSettingsUser', {
        user_id: this.userLogged.id,
        table_name: this.tableSettings.name,
      }).then(async response => {
        //window.location.reload();
        await this.getColumnSettingByUser();
        this.actionStatus.modals.columnSetting.open = await false;
      })
    },
    saveColumnSettingWithUser(){
      this.actionStatus.modals.columnSetting.loading = true;
      this.tableFields._show.forEach((item, index) => {
        if(item.width){
          this.tableFields._show[index].thStyle = "width: " + item.width + "px";
        }else{
          this.tableFields._show[index].thStyle = "width: 100px";
        }
      });

      let data = {
        fields : this.tableFields.fields,
        show : this.tableFields._show,
        hide : this.tableFields._hide
        };

      this.$store.dispatch('AuthController/updateColumnSettingsUser', {
        user_id: this.userLogged.id,
        table_name: this.tableSettings.name,
        contract_id : this.columnSettingContractId ? this.columnSettingContractId : null,
        settings: JSON.stringify(data)
      })
          .then(response => {
            this.tableFields.show = JSON.parse(JSON.stringify(response.data.data.settings.show));
            this.tableFields.hide = JSON.parse(JSON.stringify(response.data.data.settings.hide));
            this.tableFields._show = JSON.parse(JSON.stringify(this.tableFields.show));
            this.tableFields._hide = JSON.parse(JSON.stringify(this.tableFields.hide));
            this.actionStatus.modals.columnSetting.open = false;
            this.actionStatus.modals.columnSetting.resizeColumn = false;
            this.actionStatus.modals.columnSetting.loading = false;
          })
          .catch(err => {
            this.actionStatus.modals.columnSetting.open = false;
            this.actionStatus.modals.columnSetting.resizeColumn = false;
            this.actionStatus.modals.columnSetting.loading = false;
          })
    },
    updateColumnSettings(field) {
      if(!this.isUpdateFieldNotSave)
        this.isUpdateFieldNotSave = true;

      this.tableFields.show = field;
    },
    //---------------------------------------------

    // Import Data ---------------------------------------------------
    resetImport(){
      this.actionStatus.modals.import.check = '';
      this.actionStatus.modals.import.file = null;
    },
    changeFile(){
      this.actionStatus.modals.import.check = this.actionStatus.modals.import.file ? false : true;
    },
    //----------------------------------------------------------------


    // Import Data ---------------------------------------------------
    setConfig(key,value){
      this.tableSettings[key] = value;
    },
    //----------------------------------------------------------------

    //---- Build filter object --------------------------------------------
    buildFilterObject(show,hide = []){
      let fields = show.concat(hide);
      let filter = {};
      let dataSelect = {};
      for (const field of fields) {
        if(field.filter.active){
          switch(field.filter.type) {
            case "text":
              filter[field.key] = { type:field.filter.type, value: "", function: "ilike", is_customfield : field.is_customfield, attribute_id:field.attribute_id}
              break;
            case "number":
              filter[field.key] =  { type:field.filter.type, value: "", function: "=",is_customfield : field.is_customfield, attribute_id:field.attribute_id}
              break;
            case "date":
              filter[field.key] =  { type:field.filter.type, value: null, function: ">=",is_customfield : field.is_customfield, attribute_id:field.attribute_id}
              break;
            case "collection":
              filter[field.key] = { type:field.filter.type, value: '', function: "=",is_customfield : field.is_customfield, attribute_id:field.attribute_id}
              break;
            case "boolean":
              filter[field.key] = { type:field.filter.type, value: null,is_customfield : field.is_customfield, attribute_id:field.attribute_id }
              break;
            case "not-null":
              filter[field.key] =  { type:field.filter.type, value: null, function: null,is_customfield : field.is_customfield, attribute_id:field.attribute_id }
              break;
            case "null":
              filter[field.key] =  { type:field.filter.type, value: null, function: null,is_customfield : field.is_customfield, attribute_id:field.attribute_id }
              break;
            case "equal":
              filter[field.key] =  { type:field.filter.type, value: null, function: "=",is_customfield : field.is_customfield, attribute_id:field.attribute_id}
              break;
            case "percent":
              filter[field.key] =  { type:field.filter.type, value:"", function: "'>=",is_customfield : field.is_customfield, attribute_id:field.attribute_id}
              break;
            case "json_text":
              filter[field.key] =  { type:field.filter.type, value: "", function: "ilike",is_customfield : field.is_customfield, attribute_id:field.attribute_id}
              break;
            case "json_date":
              filter[field.key] =  { type:field.filter.type, value: null, function: ">=",is_customfield : field.is_customfield, attribute_id:field.attribute_id}
              break;
            case "json_collection":
              filter[field.key] =  { type:field.filter.type, value: [], function: "=",is_customfield : field.is_customfield, attribute_id:field.attribute_id}
              break;
            default:
              break;
          }
          dataSelect[field.key] = field.filter.data
        }
        this.tableRequest.filter = Object.assign(this.settings.filter, this.tableRequest.filter, filter);
        this.tableSettings.dataSelect = dataSelect;
      }
    },
    setFilterToContractID() {
      if(this.contractSelector) {
        if(this.tableRequest.filter.hasOwnProperty('contract_id')){
          if(typeof this.tableRequest.filter.contract_id == 'object') {
            this.tableRequest.filter.contract_id.value = this.contractSelector.id || null;
          }

          if(typeof this.tableRequest.filter.contract_id == 'string') {
            this.tableRequest.filter.contract_id = this.contractSelector.id || null;
          }
        }
        if(this.tableRequest.filter.hasOwnProperty('client_contract_id')){
          if(typeof this.tableRequest.filter.client_contract_id == 'object') {
            this.tableRequest.filter.client_contract_id.value = this.contractSelector.id || null;
          }

          if(typeof this.tableRequest.filter.client_contract_id == 'string') {
            this.tableRequest.filter.client_contract_id = this.contractSelector.id || null;
          }
        }
        if(this.tableRequest.filter.hasOwnProperty('contract_term_id')){
          if(typeof this.tableRequest.filter.contract_term_id == 'object') {
            this.tableRequest.filter.contract_term_id.value = this.contractSelector.contract_terms && this.contractSelector.contract_terms[0] ? this.contractSelector.contract_terms[0].id : null;
          }

          if(typeof this.tableRequest.filter.contract_term_id == 'string') {
            this.tableRequest.filter.contract_term_id = this.contractSelector.contract_terms && this.contractSelector.contract_terms[0] ? this.contractSelector.contract_terms[0].id : null;
          }
        }
      }
    },
    massPrint() {
      if(this.tableSelected.selected.length||this.tableSelected.single){
        new Promise((resolve, reject) => {
          this.$emit('mass-print', async () => {
            try {
              return {
                ids: this.tableSelected.selected.length==0 ? [this.tableSelected.single] : this.tableSelected.selected,
                filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
                resolve,
                reject,
              }
            } catch (e) {
              reject(e)
            }
          })
        })
        .then(data => {
          this.tableSelected.single = null;
        })
        .catch(err => {
          return this.$alertNotification("Can't Mass Print items", "danger");
        });
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    filtersEndorsedDORJsStatus() {
      if ( this.EndorsedDORJsStatus.status == 0 ) {          
        this.EndorsedDORJsStatus.label = '&times; Endorsed DORJs'
        this.EndorsedDORJsStatus.status = 1
      } else {
        this.EndorsedDORJsStatus.label = 'Endorsed DORJs'
        this.EndorsedDORJsStatus.status = 0
      }
      this.$emit('filter-endorsed-DORJsStatus', async () => { });
    },
    updateWONumber() {
      if(this.tableSelected.selected.length||this.tableSelected.single){
        new Promise((resolve, reject) => {
          this.$emit('update-wo-number', async () => {
            try {
              return {
                ids: this.tableSelected.selected.length==0 ? [this.tableSelected.single] : this.tableSelected.selected,
                filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
                resolve,
                reject,
              }
            } catch (e) {
              reject(e)
            }
          })
        })
        .then(data => {
          this.tableSelected.single = null;
        })
        .catch(err => {
          return this.$alertNotification("Please select a item", "danger");
        });
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    },
    btnReschedule() {
      if(this.tableSelected.selected.length||this.tableSelected.single){
        new Promise((resolve, reject) => {
          this.$emit('btn-reschedule', async () => {
            try {
              return {
                ids: this.tableSelected.selected.length==0 ? [this.tableSelected.single] : this.tableSelected.selected,
                filter: this.tableSelected.allItems ? this.tableRequest.filter :  null,
                resolve,
                reject,
              }
            } catch (e) {
              reject(e)
            }
          })
        })
        .then(data => {
          this.tableSelected.single = null;
        })
        .catch(err => {
          return this.$alertNotification("Please select a item", "danger");
        });
      }else{
        this.$alertNotification("Please select a item", "warning");
      }
    }
  }
}
</script>
